module.exports = __webpack_public_path__ + "img/slide1.6d16cbef.jpg";